import styled, { css } from 'styled-components';

type StyledHeadProps = {
  isMultipleHeaders?: boolean;
};

const Head = styled.thead<StyledHeadProps>`
  text-align: left;

  ${({ isMultipleHeaders }) =>
    !isMultipleHeaders
      ? css`
          tr:first-of-type {
            display: none;
          }
        `
      : css`
          tr:nth-of-type(2) {
            display: none;
          }
        `}
`;

const TR = styled.tr``;

const THWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const TH = styled.th`
  padding: 0.8rem;

  vertical-align: middle;
  text-align: left;
  text-transform: capitalize;

  font-weight: ${({ theme }) => theme.fontWeights.light};
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;

  height: 1.6rem;
  width: 1.6rem;
  margin-left: 0.5rem;

  font-size: 1.3rem;
`;

export { Head, IconWrapper, TH, THWrapper, TR };
